import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "../../axios";

function BlogInner() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [otherBlogs, setOtherBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`/blogs/${id}`)
      .then((res) => {
        setBlog(res.data);
      })
      .catch(() => alert("Failed to load blog"));

    axios
      .get(`/blogs`)
      .then((res) => {
        setOtherBlogs(res.data.filter((b) => b.id !== parseInt(id)));
      })
      .catch(() => alert("Failed to load other blogs"));
  }, [id]);

  if (!blog) return <div className="container py-5">Loading...</div>;

  return (
    <div className="container-fluid">
      {/* Banner Image */}
      <div className="position-relative">
        <img
          src={blog.image_url}
          alt="Blog Banner"
          className="img-fluid w-100"
        />
      </div>

      <section className="pt-0">
        <div className="container-fluid px-lg-5">
          <div className="row justify-content-between">
            {/* Blog Content */}
            <div className="col-12 col-lg-7 mb-4 plan-trends p-0">
              <div className="blog-inner-wrapper p-lg-5 p-4">
                <h5 className="blog-title mb-3">{blog.title}</h5>
                <hr />
                <div className="blog-paragraph">
                  {/* <p>{blog.description}</p> */}
                  <p>
                    <div style={{ whiteSpace: "pre-line" }}>
                      {blog.description}
                    </div>
                  </p>

                  {/* Subheading and Content */}

                  <div className="py-4">
                    <p>
                      <span className="fw-semibold">{blog.subheading}</span>
                    </p>
                    <p>
                      <div style={{ whiteSpace: "pre-line" }}>
                        {blog.content}
                      </div>
                    </p>
                  </div>

                  {/* Sections */}
                  {/* {blog.sections?.map((section, index) => (
                                        <div className="py-4" key={index}>
                                            <p><span className="fw-semibold">{section.subheading}</span></p>
                                            {/* <p>{section.content}</p> 
                                            <div style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: section.content }} />

                                        </div>
                                    ))} */}
                  {blog.sections?.map((section, index) => (
                    <div className="py-4" key={index}>
                      <p>
                        <span className="fw-semibold">
                          {section.subheading}
                        </span>
                      </p>
                      <p>
                        <div style={{ whiteSpace: "pre-line" }}>
                          {section.content}
                        </div>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar - Other Blogs */}
            <div className="col-12 col-lg-4">
              <section className="other-blogs">
                <h5 className="mb-3 mt-4">Other Blogs</h5>
                {otherBlogs.slice(0, 4).map((blog, index) => (
                  <Link
                    to={`/blog/${blog.id}`}
                    className="text-decoration-none"
                    key={index}>
                    <div className="other-blog my-lg-5 my-4">
                      <img
                        src={blog.image_url}
                        alt={blog.title}
                        className="card-img-top"
                      />
                      <div className="other-blog-title px-3 py-2">
                        <p className="text-white fw-semibold m-0">
                          {blog.title}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogInner;
